import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type AccommodationRateId = Branded<string, "AccommodationRateId">;
const AccommodationRateIdPrefix = "accommodation_rate__";
const {
    factory: accommodationRateIdFactory,
    assert: isAccommodationRateId,
    zodSchema: accommodationRateIdZodSchema,
} = genericId<AccommodationRateId>(AccommodationRateIdPrefix, {
    regexMatch: /(^accommodation_rate_.*$)/,
});

export {
    accommodationRateIdFactory,
    AccommodationRateIdPrefix,
    accommodationRateIdZodSchema,
    isAccommodationRateId,
};
export type { AccommodationRateId };
